import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import {protocolCode ,bankCode} from '../BankCode'
import './PaymentSuperFund.css';
import Util from '../util';
import { getTradeInfo,getSuperFundTradeLimit, syncCwimRiskToCamcAndStopOutOfRiskBuyPlan, syncCwimToCamcNew, hasOtsRiskRearing } from '../action/productAction';
import { Toast } from 'antd-mobile/lib';
import { getBuyFee ,buySubmit,getCurrentAdjustDetail,smSzt} from '../action/investmentAction';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { myPaymentText,myFee } from '../action/publicAction';
import PayWarmTips from './myAssets/payment/PayWarmTips'
import PayCardSuperFund from './myAssets/payment/PayCardSuperFund'
import { getUserInfoList } from '../action/loginAction';
import { findCamcHqtExist } from '../action/myAssets/userInfoAction'
import { goPubQuestionnaires } from "../getPay"

class PaymentSuperFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundLimit:'',
      isOk:false,
      agreeIndex:0,
      btnFlag:false,
      amount:'',
      fee:'--',
      fundIsOpen:'',
      tipByMax: "",
      amountMax:'0',
      popoverCount: '', //气泡金额数位文本
      popoverCountFlag: false, //数位显示标志
      showRiskModal: false,
      unionPayTransformBool: false
    };
  }
  componentWillMount() {
    document.title = "在线支付"
    this.props.dispatch(getUserInfoList((result) => {
      const inParamsData = {
        certNo: result.content.certNo,
        certType: result.content.certType,
        name: result.content.name
      }
      this.props.dispatch(findCamcHqtExist(inParamsData))
    }));
  }
  next(res){
    const { 
      dispatch,
      payInfoData,
    }=this.props;
    let {amount,fundIsOpen}=this.state;
    let {paymentText}=this.props;
    if (!Util.regular1.test(paymentText)) {
      Toast.info('请输入正确格式的金额', Util.ToastTime );
      return;
    }
    if(this.state.tipByMax) {
      Toast.info( this.state.tipByMax, Util.ToastTime );
      return;
    }
    if (amount>paymentText) {
      Toast.info( '投资金额不可低于'+amount+'元', Util.ToastTime );
      return;
    }
    try{
      if (payInfoData.currentType==1) {
        let item=payInfoData.content.yhkNewListList[payInfoData.currentIndex];
        if (!item) {
          Toast.info( '请选择支付方式', Util.ToastTime );
          return;
        } 
        if (!item.disable) {
          Toast.info( '请选择支付方式', Util.ToastTime );
          return;
        }
        if(paymentText>5000 && !payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool){
          this.setState({unionPayTransformBool: true})
          return;
        }
        if (item.tradeMaxAmountTips.split('|')[0]-0<paymentText) {
          Toast.info( item.yhkBool?item.tradeMaxAmountTips.split('|')[2]:item.tradeMaxAmountTips.split('|')[1], Util.ToastTime );
          return false;
        } 
      } else if (payInfoData.currentType==2) {
        let item=payInfoData.content.shareList[payInfoData.currentIndex];
        if (!item) {
          Toast.info( '请选择支付方式', Util.ToastTime );
          return;
        } 
        if (!item.disable) {
          Toast.info( '请选择支付方式', Util.ToastTime );
          return;
        }
        if (item.availableVolume<paymentText) {
          Toast.info( '金额不可超过活期通余额', Util.ToastTime );
          return false;
        } 
      }else if (payInfoData.currentType==3) {
        let item=payInfoData.content.currencyFund[payInfoData.currentIndex];
        if (!item) {
          Toast.info( '请选择支付方式', Util.ToastTime );
          return;
        } 
        if (item.availableVolume<paymentText) {
          Toast.info( '金额不可超过'+item.fundName+'余额', Util.ToastTime );
          return false;
        } 
      }
    }catch(e){
      console.log('金额异常')
    }
    if (fundIsOpen!=='') {
      Toast.info( fundIsOpen, Util.ToastTime );
      return;
    }
    if(payInfoData.currentType==1 && payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool){
      console.log("44444444444",payInfoData)
      const findHqtExist = this.props.findHqtExist;
      let params = {
        otsTradeAccountNo:findHqtExist.tradeAccountNo,
        raiseMethod:"9"
      }
      if(res == "1") {
        try{
          dispatch(syncCwimToCamcNew({}, (_flag) => {
            if(_flag) {
              //组合成分基金中包含华夏基金产品，需弹窗提示
              dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
                let data = result[result.length - 1].itemAdjustList;
                let fundsArr = [];
                console.log(data);
                if(this.props.prompt && this.props.prompt.replace(/(^s*)|(s*$)/g, "").length !==0){
                  this.props.parThis.setState({
                    data:this.props.prompt,
                    isShowModal2:true
                  })
                }else{
                  for (let i = 0; i< data.length; i++) {
                        if(data[i].fundName.indexOf('华夏')!= -1){
                          fundsArr.push(data[i].fundName)
                          }
                      }
                      if (fundsArr.length == 0) {
                        console.log(1)
                        this.props.parThis.setState({
                      pwdFlag:true
                        })
                      } else {
                        console.log(2)
                        this.props.parThis.setState({
                          data:fundsArr.join('、'),
                          isShowModal2:true
                        })  
                      }
                }
              }))
            }else {
              this.riskShowFun();
            }
          }))
        }catch(err){
            Toast.hide();
        }
      }else if(res == "2") {
        try{
          //组合成分基金中包含华夏基金产品，需弹窗提示
          dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
            let data = result[result.length - 1].itemAdjustList;
            let fundsArr = [];
            console.log(data);
            if(this.props.prompt && this.props.prompt.replace(/(^s*)|(s*$)/g, "").length !==0){
              this.props.parThis.setState({
                data:this.props.prompt,
                isShowModal2:true
              })
            }else{
              for (let i = 0; i< data.length; i++) {
                    if(data[i].fundName.indexOf('华夏')!= -1){
                      fundsArr.push(data[i].fundName)
                      }
                  }
                  if (fundsArr.length == 0) {
                    console.log(1)
                    this.props.parThis.setState({
                  pwdFlag:true
                    })
                  } else {
                    console.log(2)
                    this.props.parThis.setState({
                      data:fundsArr.join('、'),
                      isShowModal2:true
                    })  
                  }
            }
          }))
        }catch(err){
            Toast.hide();
        }
      }else {
        try{
            dispatch(hasOtsRiskRearing(params,(c1,c2,z1)=>{
              console.log(c1,c2,z1,"是否同步问卷")
              if(z1){
                console.log("4444444",c1,c2,z1,"是否同步问卷")
                //组合成分基金中包含华夏基金产品，需弹窗提示
                dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
                  let data = result[result.length - 1].itemAdjustList;
                  let fundsArr = [];
                  console.log(data);
                  if(this.props.prompt && this.props.prompt.replace(/(^s*)|(s*$)/g, "").length !==0){
                    this.props.parThis.setState({
                      data:this.props.prompt,
                      isShowModal2:true
                    })
                  }else{
                    for (let i = 0; i< data.length; i++) {
                          if(data[i].fundName.indexOf('华夏')!= -1){
                            fundsArr.push(data[i].fundName)
                            }
                        }
                        if (fundsArr.length == 0) {
                          console.log(1)
                          this.props.parThis.setState({
                        pwdFlag:true
                          })
                        } else {
                          console.log(2)
                          this.props.parThis.setState({
                            data:fundsArr.join('、'),
                            isShowModal2:true
                          })  
                        }
                  }
                }))
              }else{
                if(c1 === c2){
                    console.log(c1,c2,z1,"c1 === c2同步问卷")
                    dispatch(syncCwimToCamcNew({}, (_flag) => {
                      console.log(_flag,"44444444445555555555")
                      if(_flag) {
                        //组合成分基金中包含华夏基金产品，需弹窗提示
                        dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
                          let data = result[result.length - 1].itemAdjustList;
                          let fundsArr = [];
                          console.log(data);
                          if(this.props.prompt && this.props.prompt.replace(/(^s*)|(s*$)/g, "").length !==0){
                            this.props.parThis.setState({
                              data:this.props.prompt,
                              isShowModal2:true
                            })
                          }else{
                            for (let i = 0; i< data.length; i++) {
                                  if(data[i].fundName.indexOf('华夏')!= -1){
                                    fundsArr.push(data[i].fundName)
                                    }
                                }
                                if (fundsArr.length == 0) {
                                  console.log(1)
                                  this.props.parThis.setState({
                                pwdFlag:true
                                  })
                                } else {
                                  console.log(2)
                                  this.props.parThis.setState({
                                    data:fundsArr.join('、'),
                                    isShowModal2:true
                                  })  
                                }
                          }
                        }))
                      }else {
                        this.riskShowFun();
                      }
                    }))
                }else{
                  console.log(c1,c2,z1,"c1 === c2同步问卷")
                  goPubQuestionnaires(hashHistory, window.history.length, ()=>{
                    dispatch(syncCwimToCamcNew({}, (_flag) => {
                      console.log(_flag,"44444444444666666666666")
                      if(_flag) {
                        //组合成分基金中包含华夏基金产品，需弹窗提示
                        dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
                          let data = result[result.length - 1].itemAdjustList;
                          let fundsArr = [];
                          console.log(data);
                          if(this.props.prompt && this.props.prompt.replace(/(^s*)|(s*$)/g, "").length !==0){
                            this.props.parThis.setState({
                              data:this.props.prompt,
                              isShowModal2:true
                            })
                          }else{
                            for (let i = 0; i< data.length; i++) {
                                  if(data[i].fundName.indexOf('华夏')!= -1){
                                    fundsArr.push(data[i].fundName)
                                    }
                                }
                                if (fundsArr.length == 0) {
                                  console.log(1)
                                  this.props.parThis.setState({
                                pwdFlag:true
                                  })
                                } else {
                                  console.log(2)
                                  this.props.parThis.setState({
                                    data:fundsArr.join('、'),
                                    isShowModal2:true
                                  })  
                                }
                          }
                        }))
                      }else {
                        this.riskShowFun();
                      }
                    }))
                  })
                }
              }
            }))
        }catch(err){
            Toast.hide();
            console.log(err,'同步问卷失败')
        }
      }
    }else{
      console.log("444444444888")
      //组合成分基金中包含华夏基金产品，需弹窗提示
      dispatch(getCurrentAdjustDetail({superFundCode:this.props.fundCode},(result)=>{
        let data = result[result.length - 1].itemAdjustList;
        let fundsArr = [];
        console.log(data);
        if(this.props.prompt && this.props.prompt.replace(/(^s*)|(s*$)/g, "").length !==0){
          this.props.parThis.setState({
            data:this.props.prompt,
            isShowModal2:true
          })
        }else{
          for (let i = 0; i< data.length; i++) {
                if(data[i].fundName.indexOf('华夏')!= -1){
                  fundsArr.push(data[i].fundName)
                  }
              }
              if (fundsArr.length == 0) {
                console.log(1)
                this.props.parThis.setState({
              pwdFlag:true
                })
              } else {
                console.log(2)
                this.props.parThis.setState({
                  data:fundsArr.join('、'),
                  isShowModal2:true
                })  
              }
        }
      }))
    }
  }
  keyOk = () => {
    const { 
      navigator,
      payInfoData,
      businessType,
      dispatch,
    }=this.props;
    let{ fundName, fundCode}=this.props;//navigator 传入
    let _this=this;
    let {amount}=this.state;
    let {paymentText}=this.props;
    const pushResult = (i,result) => {
      if (i==1) {
        console.log("020202002020202022")
          hashHistory.push({
            pathname:'/Success',
            state: {
              title:'支付完成',
              content:'支付成功',
              dataSouse:[['申请编号',result.content.requestId],['产品名称',`${this.props.fundName}(${this.props.fundCode})`],['投资金额',Util.parsePrice(paymentText)+'元']],
              souseVal:['查看交易信息','返回我的智投'],
              businessType:payInfoData.currentType==1?"T522":payInfoData.currentType==2?"T422":payInfoData.currentType==3?"T822":"",
              superFundConfirmAndIncomeDate:result.content.confirmAndIncomeDate,
              fundCode:fundCode,
              superTypeValue: this.props.superTypeValue

            }
          });
      } else if (i==0) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'支付完成',
              content:'很抱歉，您的这笔交易支付失败',
              content2:result.content?result.content.requestDetail.paymentMessage:result,
              dataSouse:[],
              souseVal:['返回华夏智投','联系客服']
            }
          });
      }else if (i==2) {
        hashHistory.push({
          pathname:'/ErrorResult',
          state: {
            title:'支付完成',
            content:'处理中（银行返回处理中)',
            content2:'申请处理中',
            dataSouse:[],
            souseVal:['返回华夏智投','联系客服']
          }
        });
    }else if (i==3 || i==5) {
      hashHistory.push({
        pathname:'/ErrorResult',
        state: {
          title:'支付完成',
          content:'结果未知',
          content2:'申请结果未知，请等待日终状态后联系客服',
          dataSouse:[],
          souseVal:['返回华夏智投','联系客服']
        }
      });
  }else{
    hashHistory.push({
      pathname:'/ErrorResult',
      state: {
        title:'支付完成',
        content:'结果未知',
        content2:'申请结果未知，请等待日终状态后联系客服',
        dataSouse:[],
        souseVal:['返回华夏智投','联系客服']
      }
    });
}
    }

      if (payInfoData.currentType==1) {
        let item=payInfoData.content.yhkNewListList[payInfoData.currentIndex];
        console.log('银行卡交易'+payInfoData.currentIndex,item);
        if(item.yhkBool){
          let data={ //直销卡交易
              amount:Number(paymentText),
              businessType:"TH22",
              superFundCode:fundCode,
              payByHqt:false,
              bankCode: item.bankCode,
              password:Util.encrypt(this.props.keyPasswordVal),
              paymentChannel:item.paymentChannelId,
              payByOtsCards: true,
              clientType:"",
              clientDeviceNo:"",
              textval:"直销卡"
            } 
          dispatch(buySubmit(data,pushResult))
        }else{
          let data={ 
            "amount": paymentText, 
            "businessType": "T522", 
            "clientIp": "127.0.0.1", 
            "currentAccountId": item.currentAccountId, 
            "paymentChannel": item.paymentChannel, 
            "superFundCode": fundCode, 
            "payByHqt":false, 
            "riskControlFlag":"0", 
            password:Util.encrypt(this.props.keyPasswordVal),
            textval:"财富卡"
            } 
            console.log(this.props.keyPasswordVal,"898989898")
          dispatch(buySubmit(data,pushResult))
        }
      }else  if(payInfoData.currentType==2) {
        let item=payInfoData.content.shareList[payInfoData.currentIndex];
        console.log('活期通'+payInfoData.currentIndex,item)
        let data={ 
          "amount": paymentText, 
          "businessType": "T422", 
          "clientIp": "127.0.0.1", 
          "currentAccountId": item.currentAccountId, 
          "paymentChannel": item.paymentChannel, 
          "superFundCode": fundCode, 
          "payByHqt":true, 
          "riskControlFlag":"0", 
          password:Util.encrypt(this.props.keyPasswordVal),
          bankCode:item.bankCode,
          textval:"活期通"
        } 
        dispatch(buySubmit(data,pushResult))
      }else  if (payInfoData.currentType==3) {
        let item=payInfoData.content.currencyFund[payInfoData.currentIndex];
        let data={ 
          "amount": paymentText, 
          "businessType": "T822", 
          "clientIp": "127.0.0.1", 
          "currentAccountId": item.trustChannelId, 
          "paymentChannel": item.trustChannelId, 
          "superFundCode": fundCode, 
          "payByHqt":false, 
          "riskControlFlag":"0", 
          password:Util.encrypt(this.props.keyPasswordVal),
          bankCode:item.bankCode,
          bankAccountShowNo:item.bankAccountShowNo,
          payByMoneyFund:true,
          moneyFundCode:item.fundCode,
          textval:"零钱宝"
        } 
        dispatch(buySubmit(data,pushResult))
      }
    
  }
  popoverCountFun = (text) => {
    if(text>=10000 && text<100000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'万'
      })
    }else if(text>=100000 && text<1000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'十万'
      })
    }else if(text>=1000000 && text<10000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'百万'
      })
    }else if(text>=10000000 && text<100000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'千万'
      })
    }else if(text>=100000000 && text<1000000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'亿'
      })
    }else if(text>=1000000000 && text<10000000000){
      this.setState({
        popoverCountFlag:true,
        popoverCount:'十亿'
      })
    }else{
      this.setState({
        popoverCountFlag:false,
        popoverCount:''
      })
    }
  }
  componentDidMount(){
    this.fetch();
    this.props.parThis.getChildThis(this);
    this.popoverCountFun(this.props.paymentText);
  }
  fetch(){
    let { 
      dispatch, payInfoData
    } = this.props;
    let dataAmount={
        businessType:'T022',
        superFundCode:this.props.fundCode,
    }
    if (payInfoData.currentType==4) {
      dispatch(getTradeInfo(this.props.fundCode,'T522',this.props.productType,(result,i,type)=>{
        this.props.dispatch(getSuperFundTradeLimit(dataAmount,(val)=>{
          this.setState({amount:val.content.minLimit,amountMax:val.content.maxLimit})
          this.maxTipFun(this.props.paymentText, i, type, val.content.minLimit, val.content.maxLimit);
        }));
        Object.assign(result,{currentType:type},{currentIndex:i})
        dispatch({
          type:"SUPER_FUND_PAY_INFO",
          text:result
        });
      }))
    }else {
      this.props.dispatch(getSuperFundTradeLimit(dataAmount,(val)=>{
        this.setState({amount:val.content.minLimit,amountMax:val.content.maxLimit})
        this.maxTipFun(this.props.paymentText, this.props.payInfoData.currentIndex, this.props.payInfoData.currentType, val.content.minLimit, val.content.maxLimit);
      }));
    }
    
  }
  isAgreeClick(){
    let { agreeIndex } =this.state;
    if (agreeIndex===0) {
      this.setState({
        agreeIndex:1
      })
      this.props.dispatch(smSzt(1))
    } else {
      this.setState({
        agreeIndex:0,
      })
      this.props.dispatch(smSzt(0))
    }
  }

  goBack(){
    hashHistory.goBack();
  }
  ProtocolPaper(name){
    let code=protocolCode[name];
    console.log(hashHistory)
    hashHistory.push({
        pathname:'/WebView',
        state:{name:name,code:code},
        query: {code:code}
    })
  }
  choseBank(){
    hashHistory.push({
      pathname: '/paymentBankList',
      state:{
        fundCode:this.props.fundCode,
      }
    });
  }
  onChangeText(text){
    let { 
      dispatch, 
      payInfoData,
      fundCode, 
      businessType,
      productType,
    } = this.props;
    this.props.dispatch(myPaymentText(text))
    if (payInfoData.currentType==1) {
      let item=payInfoData.content.yhkNewListList[payInfoData.currentIndex];
      let data={
        paymentChannelId:item.paymentChannel,
        businessType:'T522',
        fundCode:this.props.fundCode,
        applicationAmount:text,
        payBuyHqt:true,
      }
      let data0={
        paymentChannelId:item.paymentChannel,
        businessType:'T522',
        fundCode:this.props.fundCode,
        applicationAmount:0,
        payBuyHqt:true,
      }
      // if (text.length==0) 
      //   dispatch(getBuyFee(data0,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
      // else
      //   dispatch(getBuyFee(data,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
      console.log('银行卡')
    }else  if (payInfoData.currentType==2) {
      let item=payInfoData.content.shareList[payInfoData.currentIndex];
      let data={
        paymentChannelId:item.currentAccountId,
        businessType:'T422',
        fundCode:this.props.fundCode,
        applicationAmount:text,
        payBuyHqt:true,
      }
      let data2={
        paymentChannellId:item.currentAccountId,
        businessType:'T422',
        fundCode:this.props.fundCode,
        applicationAmount:0,
        payBuyHqt:true,
      }
      // if (text.length==0) 
      //   dispatch(getBuyFee(data2,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
      // else
      //   dispatch(getBuyFee(data,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
    }else  if (payInfoData.currentType==3) {
      let item=payInfoData.content.currencyFund[payInfoData.currentIndex];
      let data={
        paymentChannelId:item.trustChannelId,
        businessType:'T822',
        fundCode:this.props.fundCode,
        applicationAmount:text,
        payBuyHqt:true,
      }
      let data2={
        paymentChannellId:item.trustChannelId,
        businessType:'T822',
        fundCode:this.props.fundCode,
        applicationAmount:0,
        payBuyHqt:true,
      }
      // if (text.length==0) 
      //   dispatch(getBuyFee(data2,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
      // else
      //   dispatch(getBuyFee(data,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
    }
    this.popoverCountFun(text);
    this.maxTipFun(text, this.props.payInfoData.currentIndex, this.props.payInfoData.currentType, this.state.amount, this.state.amountMax);
  }
  //各种限额提示
  maxTipFun = (text, i, type, amount, amountMax) => {
    this.setState({
      tipByMax: ""
    });
    if(text === null || text === "" || text === undefined) {
      return;
    }
    let yhkList = this.props.payInfoData.content.yhkNewListList;
    let hqtList = this.props.payInfoData.content.shareList;
    let lqbList = this.props.payInfoData.content.currencyFund;
    let _amount = amount === null || amount === "" || amount === undefined ? null : Number(amount);
    let _amountMax = amountMax === null || amountMax === "" || amountMax === undefined ? null : Number(amountMax);
    let _index = i;
    let _type = type;
    if(text === 0 || text === "0") {
      this.setState({
        tipByMax: "转入金额不能为0"
      });
      return;
    }
    if(_amount !== null && _amount !== "" && _amount !== undefined) {
      if(text < _amount) {
        this.setState({
          tipByMax: "转入金额低于最低限额"
        });
        return;
      }
    }
    if(_amountMax !== null && _amountMax !== "" && _amountMax !== undefined) {
      if(text > _amountMax) {
        this.setState({
          tipByMax: "转入金额超过最高限额"
        });
        return;
      }
    }
    if(_type == "1") {
      if(yhkList && yhkList.length > 0) {
        if(yhkList[_index].tradeMaxAmountTips.indexOf("|") != -1) {
          let _num = yhkList[_index].tradeMaxAmountTips.split("|")[0];
          _num = _num >= 0 ? Number(_num) : _num;
          if(_num !== null && _num !== "" && _num !== undefined) {
            if(text > _num) {
              this.setState({
                tipByMax: "转入金额超过银行卡限额"
              });
            }
          }
        }
      }
    }else if(_type == "2") {
      if(hqtList && hqtList.length > 0) {
        if(hqtList[_index].availableVolume !== null && hqtList[_index].availableVolume !== "" && hqtList[_index].availableVolume !== undefined) {
          if(text > hqtList[_index].availableVolume) {
            this.setState({
              tipByMax: "转入金额超过可用余额"
            });
          }
        }
      }
    }else if(_type == "3") {
      if(lqbList && lqbList.length > 0) {
        if(lqbList[_index].availableVolume !== null && lqbList[_index].availableVolume !== "" && lqbList[_index].availableVolume !== undefined) {
          if(text > lqbList[_index].availableVolume) {
            this.setState({
              tipByMax: "转入金额超过可用余额"
            });
          }
        }
      }
    }
  }
  resetRiskFun = () => {
    this.setState({
      showRiskModal: false
    });
    goPubQuestionnaires(hashHistory, window.history.length, ()=>{
      this.next("1");
    });
    return;
  }
  sameDataFun = () => {
    this.setState({
      showRiskModal: false
    });
    this.props.dispatch(syncCwimRiskToCamcAndStopOutOfRiskBuyPlan({}, () => {
      this.next("2");
    }));
    return;
  }
  riskShowFun = () => {
    this.setState({
      showRiskModal: true
    });
  }
  paymentMethod = () => {
    hashHistory.push({
      pathname: '/PayCardList',
      state:{
        type: 'superFund',
        actionType: 'SUPER_FUND',
        fundCode: this.props.fundCode
      }
    });
  }
  render(){
    const { 
      businessType,
      productType,
      payInfoData,
      rateAndFeeDate,
      paymentText,
    }=this.props;
    let _this=this;
    const img_arr = [require('../img/square.png'),require('../img/protocol_selected.png')]
    return (
        <div className="container">
          {/*头部*/}
          <div style={{marginTop: -10}}>
            <div style={{width: window.winWidth, backgroundColor: "#fff", paddingBottom: 15, paddingTop: 20, paddingLeft: 20, paddingRight: 20, borderTopLeftRadius: 10, borderTopRightRadius: 10}}>
              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between"}}>
                <span style={{fontSize:16,color:'#333'}}>{Util.formatStr(this.props.fundName)+'('+Util.formatStr(this.props.fundCode)+')'}</span>
                <span style={{fontSize:12,color:'#999'}}>转入</span>
              </div>
              <div style={{height:25, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                {
                  this.props.paymentText == '' ?
                  <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 40}}>
                    <span style={{color:'#999',fontSize:12}}>|</span>
                    <span style={{color:'#F8515C',fontSize:12, marginTop: 1, marginLeft: 2}}>{/* "请输入转入金额" */}</span>
                  </div>
                  :
                  null
                }
                {
                  this.state.popoverCountFlag ?
                  <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 40}}>
                    <span style={{color:'#999',fontSize:12}}>|</span>
                    <span style={{color:'#999',fontSize:12, marginTop: 1, marginLeft: 2}}>{this.state.popoverCount}</span>
                  </div>
                  :
                  null
                }
                {
                  this.state.tipByMax ?
                  <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: this.state.popoverCountFlag ? 5 : 40}}>
                    {
                      this.state.popoverCountFlag ?
                      null 
                      :
                      <span style={{color:'#999',fontSize:12}}>|</span>
                    }
                    <span style={{color:'#F8515C',fontSize:12, marginTop: 1, marginLeft: 2}}>{this.state.tipByMax}</span>
                  </div>
                  :
                  null
                }
              </div>
              <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between", paddingBottom: 9.5, borderBottomColor: "#EBEBEB", borderBottomWidth: 0.5, borderBottomStyle: "solid"}}>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                  <span style={{fontSize:24,fontWeight: "500", color: "#333"}}>¥</span>
                  <input className='price_placeholder_style' style={{fontSize: 24, color: "#333", fontWeight: "400", marginLeft: 10, width: 240}} autocomplete="off" onChange={(e)=>this.onChangeText(e.target.value)} type="text" value={this.props.paymentText} placeholder={`${Util.parsePrice(this.state.amount)}元起购`} />
                </div>
                <div onClick={() => {this.onChangeText("")}}>
                  <img
                  src = {require('../imgs/allClear_pay.jpg')}
                  style={{height: 16, width: 16}}
                  />
                </div>
              </div>
              <div style={{paddingTop: 14.5, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                <span style={{color: "#999", fontSize: 12}}>买入费率：</span>
                <span style={{fontSize:12,color:'#B69271', fontWeight: "500"}}>0-1折</span>
              </div>
            </div>
            {/*支付方式*/}
            <div style={{paddingLeft: 20, paddingRight: 20, backgroundColor: "#fff", marginTop: 10}}>
              <PayCardSuperFund type='superFund' superFundCode={this.props.fundCode} actionType='SUPER_FUND'/>
            </div>
            <div>
            {/* style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingLeft: 15, paddingRight: 25, width: window.winWidth}} */}
              <div style={{height: "auto", paddingTop: 10, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}} className='pay-agree'>
                <img src={img_arr[this.props.smSzt]} style={{width: 32, height: 32}} onClick={()=>this.isAgreeClick()}/>
                <p style={{display:'block'}}><span style={{color:'#999999',fontSize:12}}>我已阅读并同意</span>
                  {
                    this.props.fundCode == 'SF1012'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-货币')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1015'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-固收')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1016'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-权益')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1014'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-指数')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1017' || this.props.fundCode == 'SF1018'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-教育')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1019' || this.props.fundCode == 'SF1020' || this.props.fundCode == 'SF1021' || this.props.fundCode == 'SF1013'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-养老')}>《投资组合策略说明书》</span>
                    :
                    this.props.policy && this.props.policyTitle?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper(this.props.policyTitle ? this.props.policyTitle : "")}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1036'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-工资宝')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1038'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-7分小进取')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1039'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-指数增强')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1060'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-安心宝')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1067'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-价值精选')}>《投资组合策略说明书》</span>
                    :
                    this.props.fundCode == 'SF1022'?
                    <span style={{color: "#5270A3"}} onClick={()=>this.ProtocolPaper('投资组合策略说明书-货币增强')}>《投资组合策略说明书》</span>
                    :
                    null
                  }
                  <span style={{color:'#999999',fontSize:12}}>及特别提示内容</span>
                </p>
              </div>
              <div style={{width: window.winWidth, paddingLeft: 20, paddingRight: 20, marginTop: 20}}>
                {
                  this.props.smSzt==1&&Util.regular1.test(this.props.paymentText) ? 
                  <div onClick={()=>this.next()} style={{width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#fa063a", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                    <span style={{fontSize: 16, color: "#fff"}}>确定买入</span>
                  </div>
                  :
                  <div style={{width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#D3D4D6", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                    <span style={{fontSize: 16, color: "#fff"}}>确定买入</span>
                  </div>
                }
              </div>
              <div style={{marginTop:20, paddingLeft: 7, paddingRight: 7}}><PayWarmTips buyType='SF' fundLimit={this.props.fundLimit}/></div>
            </div>
          </div>
          {
            this.state.showRiskModal ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>温馨提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>活期通、闪购相关服务由华夏基金提供，根据华夏基金的评分标准，您的风险承受能力为：C1保守型。</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>根据《证券期货投资者适当性管理办法》的规定，您适合交易风险等级为R1的产品。<span style={{fontSize: 15, color: "#333", lineHeight: "20px", fontWeight: "bold"}}>您如果确定认同此风险等级评定，为了降低您的风险，我们将终止您在华夏基金已经签约的R1产品以外的计划类交易，包括定投、智能认购、定期转换等。</span></p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.resetRiskFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>重新测评</p>
                  </div>
                  <div onClick={this.sameDataFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>确认</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
          {
            this.state.unionPayTransformBool ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>温馨提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                  <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>财富卡支付方式金额不得超过5000元，请您选择其他支付方式或下载华夏财富app操作</p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={this.paymentMethod} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>修改支付方式</p>
                  </div>
                  <div onClick={()=>{this.setState({unionPayTransformBool: false})}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>确认</p>
                  </div>
                </div>
              </div>
            </div>
            :
            null
          }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    payInfoData:state.superFundPayInfo,
    paymentText:state.paymentText,
    fee:state.fee,
    findHqtExist:state.findHqtExist,
    smSzt:state.smSzt,
  }
}
export default connect(mapStateToProps)(PaymentSuperFund);



// WEBPACK FOOTER //
// ./src/components/PaymentSuperFund.js